import React, { useEffect, useState } from 'react';
import '../components/Products.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const productList = [
  {
    slug: 'homes',
    title: 'Homes',
    desc: 'Step into a home where every detail whispers luxury and every corner reflects you.',
    thumbnail: '/img/products/360-viz/1.jpg',
  },
  {
    slug: 'experience-center',
    title: 'Experience Center',
    desc: 'Exalt your real estate marketing with experience centers that breathe your brand’s story, ignite desire and turn interest into lasting commitment.',
    thumbnail: '/img/products/exp.jpg',
  },
  {
    slug: 'offices',
    title: 'Offices',
    desc: 'Work inside spaces that inspire brilliance, fuel performance, and impact the bottom line positively.',
    thumbnail: '/img/products/office.jpg',
  },
  {
    slug: 'sample',
    title: 'Sample Apartments',
    desc: 'Visualize the unbuilt—experience your space before it exists, powered by SmartVizX’s proprietary immersive tech.',
    thumbnail: '/img/products/sample.jpg',
  },
];

const Products = () => {
  const [visibleCards, setVisibleCards] = useState([]);
  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    let timeouts = [];
    setVisibleCards([]); // Reset on mount

    productList.slice().reverse().forEach((_, i) => {
      const timeout = setTimeout(() => {
        setVisibleCards(prev => [productList[productList.length - 1 - i], ...prev]);
      }, i * 400);
      timeouts.push(timeout);
    });

    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, []);

  return (
    <>
      <Navbar />
      <div className="products-page-wrapper">
        <video className="backvideo" autoPlay muted loop playsInline>
          <source src="/p1.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="products-page">
          <h2 className="section-heading">What We Do</h2>
          <p className="section-description">
            At SmartVizX, we shape spaces with intention and emotion, crafting environments that speak without a single word being said. From the flow of form to the play of light, every element is a quiet celebration of beauty, meaning and purpose.
          </p>

          <div className="product-grid">
            <AnimatePresence>
              {visibleCards.map(({ slug, title, desc, thumbnail, external }, index) => {
                const card = isMobile ? (
                  <div className="product-card" key={slug}>
                    <img src={thumbnail} alt={title} />
                    <h4>{title}</h4>
                    <p className="product-desc">{desc}</p>
                  </div>
                ) : (
                  <motion.div
                    key={slug}
                    className="product-card"
                    initial={{ x: -200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{
                      type: 'spring',
                      stiffness: 60,
                      damping: 18,
                      delay: index * 0.3,
                    }}
                  >
                    <img src={thumbnail} alt={title} />
                    <h4>{title}</h4>
                    <p className="product-desc">{desc}</p>
                  </motion.div>
                );

                return external ? (
                  <a
                    href={external}
                    key={slug + '-link'}
                    target="_blank"
                    rel="noreferrer"
                    className="product-card-wrapper"
                  >
                    {card}
                  </a>
                ) : (
                  <Link to={`/products/${slug}`} key={slug + '-link'} className="product-card-wrapper">
                    {card}
                  </Link>
                );
              })}
            </AnimatePresence>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Products;
